import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { createApiKey } from "../../api";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

function CreateApikeyComp({ onSuccess, useridvalue }) {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo")) || {};

  const [userId, setUserId] = useState(useridvalue);
  const [apiKey, setApiKey] = useState(userInfo?.apikey);
  const [flag, setFlag] = useState(false);
  const [msg, setMsg] = useState("");
  const [password, setPassword] = useState("");

  const [snackbar, setSnackbar] = useState({ open: false, severity: "", message: "" })
  const [passwordType, setPasswordType] = useState("password" || "text");

  useEffect(() => {
    try {
      let currentuser = JSON.parse(sessionStorage?.getItem("userInfo")) || {};
      setApiKey(currentuser?.apikey);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const generateNewKey = async () => {
    if (!password) {
      setSnackbar({ open: true, message: "Please Enter Password", severity: "error" })
      return
    }
    const json = { userid: userId, pwd: password };
    const res = await createApiKey(json);

    if (res?.data?.errcode !== -1) {
      setFlag(true);
      setMsg({ color: "success", msg: "API Key created successfully" });

      let currentuser = JSON.parse(sessionStorage.getItem("userInfo"));
      const newObj = { ...JSON.parse(currentuser), apikey: res?.apikey };
      sessionStorage.setItem("userInfo", JSON.stringify(newObj));

      setApiKey(newObj?.apikey);

      onSuccess();
      setTimeout(() => {
        setFlag(false);
        setMsg("");
      }, 3000);
      clearTimeout();
    } else {
      setFlag(true);
      setMsg({ color: "error", msg: res?.error?.[0] });
      setTimeout(() => {
        setFlag(false);
        setMsg("");
      }, 3000);
      clearTimeout();
    }
  };
  const invalidateKey = async () => {
    if (!password) {
      setSnackbar({ open: true, message: "Please Enter Password", severity: "error" })
      return
    }
    const json = { userid: userId, pwd: password, action: "invalidate" };
    const res = await createApiKey(json);
    // let newObj = { userid: userId, apikey: res?.data?.apikey };
    // sessionStorage.setItem('currentuser', JSON.stringify(newObj));
  };

  const onSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Box sx={{ height: "100%" }} component="main">
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ open: false, severity: '', message: "" })}>
        <Alert
          onClose={() => setSnackbar({ open: false, severity: '', message: "" })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <form onSubmit={onSubmit}>
        <Card
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box sx={{ my: 3 }}>
            <Typography color="textPrimary" variant="h6">
              Create Api Key
            </Typography>
          </Box>
          <TextField
            fullWidth
            label="User Id"
            margin="normal"
            name="UserId"
            type="text"
            variant="outlined"
            disabled={useridvalue}
            value={userId}
            error={userId?.length > 128}
            helperText={userId?.length > 128 && "max Size is 128bytes"}
            onChange={(e) => setUserId(e.target.value)}
          />
          <TextField
            fullWidth
            label="Password"
            margin="normal"
            name="password"
            type={passwordType}
            variant="outlined"
            value={password}
            error={password.length > 16}
            helperText={password.length > 16 && "max Size is 16bytes"}
            onChange={(e) => setPassword(e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => {
                  setPasswordType(
                    passwordType === "password" ? "text" : "password"
                  );
                }}
              />
            }
            sx={{ userSelect: "none" }}
            label="Show Password"
          />
          <Typography variant="body2" color="textSecondary">
            {" "}
            Your Api Key is: {apiKey}{" "}
          </Typography>

          {flag && (
            <Stack sx={{ width: "50%" }} spacing={2}>
              <Alert severity={msg.color}>{msg.msg}</Alert>
            </Stack>
          )}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              py: 2,
            }}
          >
            <Box>
              <Button
                color="error"
                size="medium"
                type="button"
                onClick={invalidateKey}
                fullWidth
                variant="contained"
              >
                Invalidate Old Key
              </Button>
            </Box>
            <Box>
              <Button
                color="primary"
                size="medium"
                type="button"
                fullWidth
                variant="contained"
                onClick={generateNewKey}
              >
                Create New Api Key
              </Button>
            </Box>
          </Box>
        </Card>
      </form>
    </Box>
  );
}

export default CreateApikeyComp;
